export const CIVIL_STATUS_OPTIONS = [
  {
    value: "single",
    description: "Soltero/a (Single)",
  },
  {
    value: "married",
    description: "Casado/a (Married)",
  },
  {
    value: "other",
    description: "Otro (Other)",
  },
];

export const GENDER_OPTIONS = [
  {
    value: "female",
    description: "Femenino (Female)",
  },
  {
    value: "male",
    description: "Masculino (Male)",
  },
];

export const DEPENDENT_TYPE_OPTIONS = [
  { value: "spouse", description: "Spouse" },
  { value: "child", description: "Child" },
];

export const EDUCATION_LEVEL_OPTIONS = [
  {
    value: "primary_school",
    description: "Diploma Primaria",
  },
  {
    value: "secondary_school",
    description: "Bachillerato Educación Diversificada",
  },
  {
    value: "university_bachelor",
    description: "Bachillerato Universitario",
  },
  {
    value: "university_technical",
    description: "Técnico Universitario",
  },
  {
    value: "university_license",
    description: "Licenciatura",
  },
];
